import type {
  AdminTenantDetailDto,
  AdminTenantListDto,
  AdminTenantMemberDto,
  AssignPlanRequest,
  Paginated,
  TenantMemberPaginationParams,
  TenantPaginationParams,
  ToggleTenantStatusRequest,
} from '../types/tenants.types';
import type { IHttpResponse } from '@/core/api/HttpClient';
import httpClient from '@/core/api/createAxiosHttpClient';

export const tenantsApi = {
  getTenants: async (
    params: TenantPaginationParams = {},
  ): Promise<IHttpResponse<Paginated<AdminTenantListDto>>> => {
    const {
      page = 1,
      pageSize = 10,
      status,
      isActive,
      countryId,
      planId,
      searchTerm,
      createdFrom,
      createdTo,
    } = params;
    return httpClient.get<Paginated<AdminTenantListDto>>('/admin/tenants', {
      params: {
        page,
        pageSize,
        ...(status != null && { status }),
        ...(isActive != null && { isActive }),
        ...(countryId != null && { countryId }),
        ...(planId != null && { planId }),
        ...(searchTerm != null && { searchTerm }),
        ...(createdFrom != null && { createdFrom: `${createdFrom}T00:00:00.000Z` }),
        ...(createdTo != null && { createdTo: `${createdTo}T23:59:59.999Z` }),
      },
    });
  },

  getTenantDetail: async (tenantId: string): Promise<IHttpResponse<AdminTenantDetailDto>> => {
    return httpClient.get<AdminTenantDetailDto>(`/admin/tenants/${tenantId}`);
  },

  getTenantMembers: async (
    tenantId: string,
    params: TenantMemberPaginationParams = {},
  ): Promise<IHttpResponse<Paginated<AdminTenantMemberDto>>> => {
    const { page = 1, pageSize = 10 } = params;
    return httpClient.get<Paginated<AdminTenantMemberDto>>(`/admin/tenants/${tenantId}/members`, {
      params: { page, pageSize },
    });
  },

  suspendTenant: async (
    tenantId: string,
    data: ToggleTenantStatusRequest,
  ): Promise<IHttpResponse<object>> => {
    return httpClient.patch<object>(`/admin/tenants/${tenantId}/suspend`, data);
  },

  reactivateTenant: async (
    tenantId: string,
    data: ToggleTenantStatusRequest,
  ): Promise<IHttpResponse<object>> => {
    return httpClient.patch<object>(`/admin/tenants/${tenantId}/reactivate`, data);
  },

  /** Otorga un plan sin checkout. Es la unica via por la que un plan privado llega aqui. */
  assignPlan: async (tenantId: string, data: AssignPlanRequest): Promise<IHttpResponse<void>> => {
    const response = await httpClient.put<AssignPlanRequest>(
      `/admin/tenants/${tenantId}/plan`,
      data,
    );
    return { ...response, data: undefined as unknown as void };
  },

  revertPlanAssignment: async (
    tenantId: string,
    reason: string | null,
  ): Promise<IHttpResponse<void>> => {
    return httpClient.delete<void>(`/admin/tenants/${tenantId}/plan`, { reason });
  },
};
